<dx-data-grid id="gridContainer" [dataSource]="solicitudes">
  <dxo-search-panel [visible]="false"></dxo-search-panel>
  <dxo-group-panel [visible]="false"></dxo-group-panel>
  <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

  <!-- Definición de las columnas -->

  <dxi-column dataField="FechaSolicitud" caption="Fecha" dataType="date" alignment="right"></dxi-column>
  <dxi-column dataField="Dias" caption="Días"> </dxi-column>
  <dxi-column dataField="Importe" caption="Importe">
    <dxo-format type="currency" [precision]="2"></dxo-format>
  </dxi-column>
  <dxi-column dataField="Observaciones" caption="Observaciones">
  </dxi-column>
</dx-data-grid>
